<template>
<v-container>
    <v-row>
        <v-col cols="12">
            <v-toolbar color="indigo" dark>
                <v-toolbar-title>Select a Shipment</v-toolbar-title>
            </v-toolbar>
            <v-card>

              <v-card
                v-for="(shipment, index) in shipments"
                :key="index"
                v-bind:color="cardClicked === index || routeID === shipment.objectID ? 'red' : 'white'"
                @click="selectRoute(index, shipment.objectID)"
              >
                <v-card-title primary-title class="justify-center">
                    {{shipment.type + " - " + shipment.objectID}}
                </v-card-title>
              </v-card>

            <v-card>
              <HereMap style="width: 100%; height: 500px" :shipments="shipments" :cardClicked="cardClicked" :shipmentID="shipmentID" v-on:routeClicked="changeColor($event)" />
            </v-card>

            </v-card>
        </v-col>
    </v-row>
    </v-container>
</template>

<script>
import { algoliaService } from '@/_services'
import HereMap from '@/components/maps/HereMap'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Maps',
  components: {
    HereMap
  },
  props: {},
  data () {
    return {
      shipments: [],
      cardClicked: -1,
      shipmentID: null,
      routeID: ''
    }
  },
  computed: {
    ...mapState(['generalApp'])
  },
  methods: {
    ...mapActions({
      setSelectedShipment: 'setSelectedShipment'
    }),
    selectRoute (index, id) {
      if (index === this.cardClicked) {
        this.cardClicked = -1
        this.shipmentID = null
      } else {
        this.setSelectedShipment(id)
        this.cardClicked = index
        this.shipmentID = this.generalApp.selectedSchipment
      }
    },
    changeColor (data) {
      this.routeID = data
    }
  },
  created () {
    // retrieves shipments data from algolia
    let shipments = algoliaService.getHits('prod_shipments')
    shipments.then((result) => {
      let shipments = result.hits
      // filter the result so I get only the 1PL shipments
      this.shipments = shipments.filter(function (el) {
        return el.type === '1PL'
      })
      return result
    })
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
</style>
